import React from "react";
import { useParams } from "react-router-dom";
import SeoLandingPage from "@/pages/public/SeoLandingPage";
import NotFound from "@/pages/public/NotFound";
import { MOBILITA_PAGES } from "@/data/site";

export default function MobilitaLanding() {
  const { slug } = useParams();
  const data = MOBILITA_PAGES[slug];
  if (!data) return <NotFound />;
  return (
    <SeoLandingPage
      data={data}
      category="Mobilità senior"
      crumbs={[{ label: "Mobilità", path: "/mobilita" }, { label: data.title }]}
    />
  );
}
